import React from 'react';
import Button from '@material-ui/core/Button';
//import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import FileViewer from 'react-file-viewer';

export default class ViewDialog extends React.Component {
  state = {
    open: false,
    title: null,
    message: null,
    value:null,
    callBack: null
  };

  show(id,type){
    this.setState({open:true,id:id,type:type});
  }

  handleOk = () => {
    this.setState({ open: false });
    if(this.state.callBack){
        this.state.callBack(this.state.value);
    }
  };

  handleClose = () => {
    this.setState({ open: false });
  };
  onChange = (e) => {
    this.setState({value:e.target.value});
  }
  render() {
    const t = this.state.type === 'doc'? 'docx' : this.state.type;
    return (
      
        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">{this.state.title}</DialogTitle>
          <DialogContent>
            <DialogContentText>
              {this.state.message}
            </DialogContentText>
            <FileViewer style={{height:'500px'}} fileType={t} filePath={'api/docx/download/'+ this.state.id} onError={e => alert('error')}/>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary">
              Cancel
            </Button>
            <Button onClick={this.handleOk} color="primary">
              Ok
            </Button>
          </DialogActions>
        </Dialog>
    );
  }
}